import React from "react";
import MarketTile from "components/Market/MarketTile/MarketTile";

import styles from "./style.module.css";

const MarketManagement = (props) => {
  const { jobs, type, updateIsReviewingJob, viewAndStartReplay, history } = props;

  const jobStages = ["open", "worked", "completed"];

  const renderTile = (data, stage) => {
    return (
      <div className={styles.managementTileContainer}>
        <MarketTile
          history={history}
          data={data}
          type={type}
          stage={stage}
          viewAndStartReplay={viewAndStartReplay}
          updateIsReviewingJob={updateIsReviewingJob}
        />
      </div>
    );
  };

  return (
    <div className={styles.managementContainer}>
      <div className={styles.managementHeader}>Recent Job Postings</div>
      <div className={styles.managementColumnsContainer}>
        <div className={styles.managementColumn}>
          <div className={styles.managementColumnHeader}>Open Jobs</div>
          <div className={styles.managementColumnContentSection}>
            {renderTile(jobs[0], jobStages[0])}
            {renderTile(jobs[1], jobStages[0])}
          </div>
        </div>
        <div className={styles.managementColumn}>
          <div className={styles.managementColumnHeader}>Jobs Being Worked On</div>
          <div className={styles.managementColumnContentSection}>{renderTile(jobs[2], jobStages[1])}</div>
        </div>
        <div className={styles.managementColumn}>
          <div className={styles.managementColumnHeader}>Completed Work</div>
          <div className={styles.managementColumnContentSection}>{renderTile(jobs[3], jobStages[2])}</div>
        </div>
      </div>
    </div>
  );
};

export default MarketManagement;
